import React, { Component } from "react";
import HasPermissionTo from "../../../../common/HasPermissionTo";
import styles from "../OrderDetailsNewVersion.module.scss";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";

class BackToSearchResults extends Component {
  render() {
    return (
      <HasPermissionTo
        perform={["backToSearchResults"]}
        permissions={this.props.user.permissions.rolePermissions}
        condition={!this.props.fromNscDealerSearch}
        render={() => (
          <div className={styles.orderNumberHeader}>
            <button
              className={styles.back}
              onClick={() =>
                this.props.showOrderDetails(
                  this.props.commonDealerId,
                  null,
                  false
                )
              }
            >
              <KeyboardArrowLeftIcon fontSize="small" />
              <span className={styles.backToOrderText}>
                {this.props.t("CustomerOrderDetails.back")}
              </span>
            </button>
            {this.props.showOrderId && (
              <span className={styles.orderNumber}>
                {this.props.herculesCanViewDealerType
                  ? this.props.getOrderType(this.props.dealerType)
                  : ""}
                &nbsp;{this.props.t("CustomerOrderDetails.orderId")}
                &nbsp; {this.props.customerReservation.id}
              </span>
            )}
          </div>
        )}
        noRender={() => (
          <div className={styles.orderNumberHeader}>
            <Link
              className={styles.back}
              id="back-button"
              to="/dealer/customer-reservations"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
              <span className={styles.backToOrderText}>
                {this.props.t("CustomerOrderDetails.back")}
              </span>
            </Link>
            {this.props.showOrderId && (
              <span className={styles.orderNumber}>
                {this.herculesCanViewDealerType
                  ? this.getOrderType(this.props.dealerType)
                  : ""}
                &nbsp;{this.props.t("CustomerOrderDetails.orderId")}
                &nbsp; {this.props.customerReservation.id}
              </span>
            )}
          </div>
        )}
      />
    );
  }
}

export default withTranslation("emp")(BackToSearchResults);
